import DuplicatePinPlate from '../../product/duplicate-pin-plate/components/index';

export default {
    component: DuplicatePinPlate,
    name: 'DUPLICATE_PIN_PLATE',
    path: 'pin/plate/:pinPlateId'
};



// WEBPACK FOOTER //
// ./src/routes/products/duplicate-pin-plate-reports-route.js